import { shallowEqual, useSelector } from 'react-redux';
import { getGameSettings } from '../selectors';
import { IStore } from 'store/interface';

export const useModuleSettings = (moduleName: string) => ({
  settings: useSelector((state: IStore) => getGameSettings(state, moduleName), shallowEqual),
});
